import * as actionTypes from "./actionTypes";

// Mall Voucher List
export const mallVoucherList = data => {
  return {
    type: actionTypes.MALL_LOAD_VOUCHER_LIST,
    data
  };
};
export const mallVoucherListSuccess = data => {
  return {
    type: actionTypes.MALL_LOAD_VOUCHER_LIST_SUCCESS,
    data
  };
};
